export const config = {
  api_url: process.env.VUE_APP_API_URL,
  token_key: "user-auth",
  firebaseConfig: {    
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
  },
  vapidKey:process.env.VUE_APP_FIREBASE_VAPIDKEY,
  map:{
    token: process.env.GOOGLE_API_KEY
  }
};
